angular.module('form.date-picker', ['datePicker']).run(['$templateCache', function($templateCache) {

  $templateCache.put('templates/datepicker.html', require('./main.pug'));
  $templateCache.put('templates/daterange-holder.html', require('./range-holder.pug'));
  $templateCache.put('public/invoice/employee/list/version/date-picker', require('../../public/invoice/employee/list/version/date-picker.pug'));

}]);
